(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3HandicapCard', {
            templateUrl: 'app/shared/handicap-card/handicap-card.component.html',
            controller: HandicapCardComponent,
            bindings: {
                card: '<'
            }
        });

    var $ = angular.element,
        GC_LOGO = '/images/handicap-card/GC.png';

    HandicapCardComponent.$inject = ['$locale', '$window', '$element', 'managementGroups', 'emailModal', 'defaultHandicapCardEmailTitle', 'defaultHandicapCardEmailSubject', 'cultureName'];
    function HandicapCardComponent($locale, $window, $element, managementGroups, emailModal, defaultHandicapCardEmailTitle, defaultHandicapCardEmailSubject, cultureName) {
        var ctrl = this,
            anchor,
            cardElement;

        // Properties
        ctrl.rows = range(4);
        ctrl.columns = range(5);
        ctrl.golfCanadaLogo = toAbsoluteUrl(GC_LOGO);        

        // Core Methods
        ctrl.$onInit = init;
        ctrl.printCard = printCard;
        ctrl.emailCard = emailCard;

        // Other Methods
        ctrl.getWelcomeUrl = getWelcomeUrl;
        ctrl.getHoleNumber = getHoleNumber;
        ctrl.getScore = getScore;
        ctrl.getLogo = getLogo;
        

        ///////////////////////////////////////////

        // ** Core Methods
        function init() {
            cardElement = $($element[0].querySelector('.hcc-handicap-card'));
        }
        function printCard() {
            var body = $(document.body),
                clone = cardElement.clone().addClass('print-only');

            $(document.body).append(clone);
            // $(document.body).addClass('print-test');
            $window.print();
            clone.remove();
        }

        function emailCard() {
            var email = {
                title: defaultHandicapCardEmailTitle,
                address: ctrl.card.email,
                subject: defaultHandicapCardEmailSubject,
                body: cardElement.parent().html() 
            }
            emailModal(email);
        }

        // ** Other Methods
        function getWelcomeUrl() {
            var lang = getLanguage();
            var welcomeUrl = 'pdf/DigitalWelcomeBook2020-{0}.pdf'.format(lang);                                    
            return welcomeUrl;
        }

        function getHoleNumber(row, col) {
            return row * ctrl.columns.length + 1;
        }
        function getScore(row, col) {
            var scores = ctrl.card.scores,
                score = scores && scores[row * ctrl.columns.length + col];
            return score && score.score && score.score + (score.type || '') + (score.isUsedInCalc ? '*' : '');
        }
        function getLogo() {
            var metadata = managementGroups.$metadata[ctrl.card.clubManagementGroup];
            return metadata && metadata.imgHandicapCard && toAbsoluteUrl(metadata.imgHandicapCard) || null;
        }
       
        function getLanguage() {
            return $locale.id === cultureName.fr.toLowerCase() || $locale.id === cultureName.fr_CA.toLowerCase() ? 'fr-CA' : 'en-CA';
        }

        // * Helpers
        function range(length) {
            return Array.apply(null, new Array(length)).map(function (_, i) { return i; });
        }

        function toAbsoluteUrl(relativeUrl) {
            if (!anchor)
                anchor = document.createElement('a');
            anchor.href = relativeUrl;
            return anchor.href;
        }
    }
})();